import { BaseDto } from "./base.dto"

import { FileDto } from "./file.dto"
import { PagingDto } from "./paging.dto"

export class BannerPopupDataDto {
  discount: number
  discountType: string
}

export class FindBannerPopupDto extends PagingDto {
  type?: string
}

export class BannerPopupDto extends BaseDto {
  image: FileDto
  mobileImage: FileDto
  totalPreview: number
  totalPreviewPerDay: number
  count: number
  enabled: boolean
  lastSeenDays: number
  type: string
  data: BannerPopupDataDto
  url: string

  static create() {
    return new BannerPopupDto()
  }
}

export class CreateBannerPopupDto {
  imageId: string
  mobileImageId: string
  totalPreview: number
  totalPreviewPerDay: number
  lastSeenDays?: number
  url?: string
}

export class UpdateBannerPopupDto {
  imageId?: string
  mobileImageId?: string
  totalPreview?: number
  totalPreviewPerDay?: number
  enabled?: boolean
  lastSeenDays?: number
  url?: string
  data?: any
}